/**
 * Component for a risk analysis document card — the original PDF plus, when
 * showTranslations is on, its translated versions and a "request translation"
 * action. Collapsible, following this codebase's existing react-collapse idiom.
 *
 * @author Robbe De Geyndt <robbe.degeyndt@aware.be>
 */

'use strict';

//imports
import React from 'react';
import {Collapse} from 'react-collapse';
import {ProgressBar} from 'react-bootstrap';
import CustomTranslation from '../../Components/CustomTranslation';

//define class
class RiskAnalysisDocumentSection extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //state
        this.state = {
            collapsed: false
        }
    }

    //render view
    render = () => {

        let showTranslations = ('showTranslations' in this.props) ? this.props.showTranslations : true;

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className={'bordered rounded'}>

                    {/* Header — click toggles collapse */}
                    <div
                        className={'standard-padding vertical-padding touchable'}
                        style={{display: 'flex', flexDirection: 'row'}}
                        onClick={() => this.setState({collapsed: !this.state.collapsed})}
                    >
                        <div>
                            <div
                                className={'bg-dark'}
                                style={{
                                    height: '1.5rem',
                                    width: '1.5rem',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <i className={'las la-file-pdf text-white'} style={{fontSize: '1rem'}} />
                            </div>
                        </div>
                        <div className={'standard-margin-2'} style={{marginRight: 0, flexGrow: 1, flexShrink: 1}}>
                            <h5 className={'unbold'}><CustomTranslation value={'KEY.Download'} /></h5>
                            <h3>{this.props.title}</h3>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            {(typeof this.props.onMailPress === 'function') &&
                                <div
                                    className={'bg-dark touchable icon-btn-container standard-margin-2'}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        this.props.onMailPress();
                                    }}
                                >
                                    <i className={'las la-share-square text-white icon-btn'} />
                                </div>
                            }
                            <div style={{width: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <i
                                    style={{fontWeight: '900', fontSize: '1rem'}}
                                    className={this.state.collapsed ? 'las la-chevron-down' : 'las la-chevron-up'}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Busy indicator — indeterminate, mirrors the existing RAItem.js download-button pattern */}
                    {this.props.progress &&
                        <div className={'standard-padding'} style={{paddingBottom: '0.75rem'}}>
                            <ProgressBar striped animated variant={'primary'} now={100} />
                        </div>
                    }

                    {/* Collapsible language list */}
                    <Collapse isOpened={!this.state.collapsed}>
                        <div className={'bordered-top'}>

                            {/* Original row */}
                            <div
                                className={'standard-padding vertical-padding-2 bordered-bottom-light'}
                                style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                            >
                                <span
                                    className={'bg-primary text-white standard-margin-2'}
                                    style={{marginLeft: 0, borderRadius: 4, padding: '2px 6px', fontSize: '0.7rem', fontWeight: 600}}
                                >
                                    <CustomTranslation value={'KEY.Original'} />
                                </span>
                                <p style={{flexGrow: 1, flexShrink: 1, margin: 0}}>{this.props.originalLanguageLabel || 'Nederlands'}</p>
                                {(typeof this.props.onDownloadOriginal === 'function') &&
                                    <div className={'bg-dark touchable icon-btn-container'} onClick={this.props.onDownloadOriginal}>
                                        <i className={'las la-download text-white icon-btn'} />
                                    </div>
                                }
                            </div>

                            {showTranslations &&
                                <React.Fragment>

                                    {/* Translated version rows */}
                                    {(this.props.translations || []).map((t, i) => {
                                        const isPending = t.status === 'pending';
                                        return (
                                            <div
                                                key={i}
                                                className={'standard-padding vertical-padding-2 bordered-bottom-light'}
                                                style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
                                            >
                                                <span
                                                    className={(isPending ? 'bg-primary text-white' : 'bg-light text-dark') + ' standard-margin-2'}
                                                    style={{marginLeft: 0, borderRadius: 4, padding: '2px 6px', fontSize: '0.7rem', fontWeight: 600}}
                                                >
                                                    <CustomTranslation value={isPending ? 'KEY.Pending' : 'KEY.Translated'} />
                                                </span>
                                                <p style={{flexGrow: 1, flexShrink: 1, margin: 0}}>{t.label}</p>
                                                {(!isPending && typeof t.onDownload === 'function') &&
                                                    <div className={'bg-dark touchable icon-btn-container'} onClick={t.onDownload}>
                                                        <i className={'las la-download text-white icon-btn'} />
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })}

                                    {/* Request translation */}
                                    {!this.props.disableRequestTranslation &&
                                        <div className={'standard-padding vertical-padding-2'}>
                                            <div
                                                className={'touchable rounded dashed-bordered-primary'}
                                                style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '0.6rem 0.75rem'}}
                                                onClick={this.props.onRequestTranslation}
                                            >
                                                <i className={'las la-plus'} style={{color: '#fdb019'}} />
                                                <span className={'standard-margin-2'} style={{color: '#fdb019'}}>
                                                    <CustomTranslation value={'KEY.Request translation'} />
                                                </span>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            }

                        </div>
                    </Collapse>

                </div>
            </div>
        );
    }
}

//export
export default RiskAnalysisDocumentSection;
